import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fromConsignmentSummaryResponse } from '../models/mapper'
import { ConsignmentSummary } from '../models/types'
import { fetchConsignmentSummaryV3 } from './http'

export async function fetchConsignmentSummary(id: number): Promise<ConsignmentSummary> {
  const response = await fetchConsignmentSummaryV3(id)
  return fromConsignmentSummaryResponse(response)
}

export function useFetchConsignmentSummary(consignmentId: number | null) {
  return useQuery({
    queryKey: QueryKeys.consignment.summary(consignmentId),
    enabled: !!consignmentId,
    queryFn: () => fetchConsignmentSummary(consignmentId as number),
  })
}
